import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, ImageListItem, ImageListItemBar, Skeleton } from '@mui/material';
import { isNil } from 'lodash';
import { useState, type DetailedHTMLProps, type FC, type ImgHTMLAttributes } from 'react';
import ImagePlaceholder from './ImagePlaceholder';

interface GalleryImageProps
  extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  onDelete?: VoidFunction;
  onImageClick?: VoidFunction;
}

type LoadingState = 'loading' | 'loaded' | 'error';

const GalleryImage: FC<GalleryImageProps> = ({
  alt,
  onDelete,
  onImageClick,
  ...other
}) => {
  const [loadingState, setLoadingState] = useState<LoadingState>('loading');

  const loading = loadingState === 'loading';
  const isError = loadingState === 'error';

  const handleImageLoad = (): void => {
    setLoadingState('loaded');
  };

  const handleImageLoadError = (): void => {
    setLoadingState('error');
  };

  return (
    <ImageListItem>
      {loading && (
        <Skeleton
          variant='rectangular'
          width={'auto'}
          height={'auto'}
          sx={{ aspectRatio: '1 / 1', position: 'absolute', bottom: 0, top: 0 }}
        />
      )}
      {isError && (
        <ImagePlaceholder
          alt={alt ?? ''}
          sx={{
            aspectRatio: '1 / 1',
            position: 'absolute',
            bottom: 0,
            top: 0,
          }}
        />
      )}
      <img
        alt={alt}
        loading='lazy'
        style={{ aspectRatio: '1 / 1', cursor: 'pointer' }}
        onLoad={handleImageLoad}
        onError={handleImageLoadError}
        onClick={onImageClick}
        {...other}
      />

      <ImageListItemBar
        title={alt}
        // subtitle={item.author}
        actionIcon={
          isNil(onDelete) ? undefined : (
            <IconButton
              onClick={onDelete}
              sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
              aria-label={`Удалить ${alt ?? ''}`}>
              <DeleteIcon />
            </IconButton>
          )
        }
      />
    </ImageListItem>
  );
};

export default GalleryImage;
